<script lang="ts">
    export let title = 'ATENCIÓN:';
    export let message = '';
</script>

<div class="alert mb-1">
    {#if title}<strong>{title}</strong> {/if}{message}
</div>

<style>
    .alert {
        background: #FFF7EA;
        border: 1px solid #FF8E27;
        color: #FF8E27;
        font-size: 15px;
    }

    .alert > * {
        color: #FF8E27;
    }
</style>